import { ReactComponent as EventIcon } from '@assets/icons/sprite_icons/warning_event.svg';
import { Box, Icon } from '@chakra-ui/react';
import { Tooltip } from '@components/ui/tooltip';

import { ReplayEvent } from '@/types/replay/replay.types';

import EventTooltip from './EventTooltip';

type Props = {
  event: ReplayEvent;
  timelineStart: number;
  timelineEnd: number;
  containerWidth: number;
};

export default function TimelineEvent({ event, timelineStart, timelineEnd, containerWidth }: Readonly<Props>) {
  if (timelineStart === timelineEnd) {
    return <></>;
  }
  const eventStart = new Date(event.startDate).getTime();
  const eventPosition = ((eventStart - timelineStart) / (timelineEnd - timelineStart)) * containerWidth;
  return (
    <Tooltip content={<EventTooltip event={event} />}>
      <Box
        position="absolute"
        height="32px"
        width="32px"
        top="100px"
        transform="translateX(-50%)"
        left={`${eventPosition}px`}
        zIndex="1"
      >
        <Icon as={EventIcon} height="32px" width="32px" />
      </Box>
    </Tooltip>
  );
}
